import { writable } from 'svelte/store'

const errors = writable({});
const isValid = writable(false);
const isChanged = writable(false);

function resetValidation(){
    errors.set({})
    isValid.set(false)
    isChanged.set(false)
}


export default { errors, isValid, isChanged, resetValidation }


